export type CountrySelectOption = {
  value?: string;
  label: string;
  divider?: boolean;
};

export type CountrySelectionResult =
  | { type: "select"; country: string | undefined }
  | { type: "ignore" };

// The country <select> can emit corrupted keys: on iOS the native HeroUI
// select forwards the raw key string to setSelectedKeys, which iterates it per
// character and (in single-selection mode) keeps only the first — truncating a
// two-letter code such as "SI" to "S". Forwarding that to react-phone-number-input
// crashes libphonenumber-js with "Unknown country". Only accept "ZZ" (the
// international option) or a value that maps to a real country option.
export function resolveCountrySelection(
  value: string,
  options: CountrySelectOption[],
): CountrySelectionResult {
  if (value === "ZZ") {
    return { type: "select", country: undefined };
  }

  const isKnownCountry = options.some(
    (option) => !option.divider && option.value === value,
  );

  return isKnownCountry
    ? { type: "select", country: value }
    : { type: "ignore" };
}
